import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const currentUser = authService.currentUser();
    const expectedRoles = route.data['expectedRoles'] as string[];

    const userRole = currentUser?.role;

    if (userRole === 'ROLE_ADMIN') {
        return true;
    }

    if (expectedRoles && expectedRoles.includes(userRole || '')) {
        return true;
    }

    // default to admin check if no expected roles provided (backward compatibility)
    if (!expectedRoles && userRole === 'ROLE_ADMIN') {
        return true;
    }

    router.navigate(['/forbidden']);
    return false;
};
